import ReactECharts from 'echarts-for-react'

export interface RadarAxis {
  name: string
  value: number // 0–100, higher = worse
}

// Org-level risk radar. Neutral axis colors read on both light and dark themes;
// the series is the ST brand primary with a translucent fill.
export function RiskRadar({ axes }: { axes: RadarAxis[] }) {
  const option = {
    tooltip: {
      trigger: 'item',
      formatter: () =>
        axes.map((a) => `${a.name}: <b>${Math.round(a.value)}</b>/100`).join('<br/>'),
    },
    radar: {
      indicator: axes.map((a) => ({ name: a.name, max: 100 })),
      radius: '65%',
      splitNumber: 4,
      axisName: { color: '#64748b', fontSize: 11 },
      splitLine: { lineStyle: { color: 'rgba(100,116,139,0.25)' } },
      splitArea: { areaStyle: { color: ['rgba(100,116,139,0.04)', 'rgba(100,116,139,0.08)'] } },
      axisLine: { lineStyle: { color: 'rgba(100,116,139,0.25)' } },
    },
    series: [
      {
        type: 'radar',
        data: [
          {
            value: axes.map((a) => Math.round(a.value)),
            name: 'Org risk',
            symbolSize: 4,
            lineStyle: { color: '#254F71', width: 2 },
            itemStyle: { color: '#254F71' },
            areaStyle: { color: 'rgba(37,79,113,0.35)' },
          },
        ],
      },
    ],
  }
  return <ReactECharts option={option} style={{ height: '100%', width: '100%' }} notMerge />
}
